import React from "react";
import _ from "lodash";
import { Table, TableHeader, Row, Cell } from '@leafygreen-ui/table';
import { FaCheck, FaPrint, FaQrcode, FaTimes } from "react-icons/fa";
import Banner  from '@leafygreen-ui/banner'
import Tooltip from "@leafygreen-ui/tooltip";
import IconButton from "@leafygreen-ui/icon-button";
import Button from '@leafygreen-ui/button'
import PageMenuHeader from "components/PageMenuHeader";

const PickingStocks = ({ finishedGoods, handlePrintLabel, handlePrintLabelByFlag, TotalPickupQty, isSessionValid, settings}) => {
  console.log('* PickingStocks init')
  // console.log("- finishedGoods", finishedGoods);

  let columns = [
    <TableHeader label="SKU" />,
    <TableHeader label="Inventory Location" />,
    <TableHeader label="Ordered" dataType="number"/>,
    <TableHeader label="Label Printed(Picked)" dataType="number"/>,
    <TableHeader label="Status" />,
    <TableHeader label="Category" />,
    <TableHeader label="Color" />,
    <TableHeader label="Location Code" style={{display: !settings?.useMultipleLocations && 'none'}}/>,
    <TableHeader label="Action" />
  ]

  // if(settings?.useMultipleLocations) columns.splice(6, <TableHeader label="Location Code" />)
  // console.log(columns)
  return (
    <div className="collection-items collection">
      {
        Boolean(finishedGoods.length) && (
          <div className="mt-10">
              <PageMenuHeader>
                <Button
                  variant="primary"
                  className="swing-icon"
                  onClick={() => handlePrintLabelByFlag({states: finishedGoods, flag: "fg"})}
                  leftGlyph={<FaPrint/>}
                  disabled={!isSessionValid.current}
                >
                  Print finished goods labels
                </Button>
                <Banner>
                  <TotalPickupQty states={finishedGoods} />
                </Banner>
            </PageMenuHeader>
          </div>
        )
      }
      {!finishedGoods ? (
        <p>loading...</p>
      ) : (
        <Table
          data={finishedGoods}
          columns={columns}
        >
          {({datum}) => {
            // console.log('- datum: ', datum)
            const ordered = _.sumBy(datum?.packing_docs, 'quantity')
            const picked = _.sumBy(datum?.packing_docs, 'pickedQty')
            // const isMeta =  _.filter(datum?.packing_docs, doc => doc?.meta ).length > 0
            // console.log('- isMeta ', isMeta )
            return (
              <Row key={datum.sku}>
                <Cell>{datum?.sku ? datum.sku : "undefined*"}</Cell>
                <Cell>
                  {datum?.picking_suggests.map((p, index) => {
                    // console.log('- p: ', p)
                    return <span key={index} className="blue each-inventory-area white-text">{p?.areaCode}: {p?.picking_qty}</span>
                  })}
                </Cell>

                <Cell>{ordered}</Cell>
                <Cell>{picked}</Cell>
                <Cell>
                  <span className="inline-block text-center" style={{minWidth: '30px'}}>
                    {
                      ordered <= picked
                        ? <FaCheck color="#09804C"/>
                        : <FaTimes color="#B1371F"/>
                    }

                  </span>
                </Cell>
                <Cell>{datum?.category ? datum.category : ""}</Cell>
                <Cell>{datum?.color ? datum.color : ""}</Cell>
                <Cell style={{display: !settings?.useMultipleLocations && 'none'}}>{datum?.locationCode ? datum.locationCode : ""}</Cell>
                <Cell>
                    <Tooltip
                      align="left"
                      justify="start"
                      className='lg-tooltip-container'
                      darkMode={true}
                      trigger={
                        <IconButton
                          onClick={() => handlePrintLabel({ data: datum, flag: 'fg', from: 'action' })}
                          className="swing-icon"
                          aria-label="Print a label"
                          disabled={!isSessionValid.current}
                        >
                          <FaQrcode />
                        </IconButton>}
                      triggerEvent="hover"
                    >
                      Print label(s)
                    </Tooltip>
                </Cell>
                
              </Row>
            )
          }}

        </Table>       
      )}
    </div>
  );
};

export default React.memo(PickingStocks);

